import React from 'react';
import { ReactSVG } from 'react-svg';
import { useTheme } from 'styled-components';
import { colorizeSvg } from '~/utils/svg/utils';
import useAuthenticationState from '~/ducks/authentication/use-authentication-state';
import * as S from './styled';

export const NavbarLogo = () => {
  const theme = useTheme();
  const { logoLink } = useAuthenticationState();
  return (
    <S.WrapperLink id="navbarLogo" data-testid="NavbarLogo" to={logoLink}>
      <S.LogoDiv>
        <ReactSVG
          src="/images/hfs_logo.svg"
          className="svg"
          beforeInjection={colorizeSvg(theme.colors.onSurface)}
        />
      </S.LogoDiv>
      <S.SeparatorDiv></S.SeparatorDiv>
      <S.TitleDiv>Husqvarna Fleet Services</S.TitleDiv>
    </S.WrapperLink>
  );
};

export default NavbarLogo;
